// fetch agreements from TermsCondition collections
// do checkbox validation
// pass agreement id, user id, account id, email id, company name, ip address
// backend => userAgreement collection entry + update Accepted flag in user collection
import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MuiThemeProvider,
    withStyles
} from '@material-ui/core';
import AgreementTermsStyle from './AgreementTermsStyle';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import cs from 'classnames';
import Auxiliary from 'hoc/Auxiliary';
import { toggleTerms } from '../../store/actions/termsAndConditionsActions';
import { DEFAULT_THEME } from 'theme/CommonTheme';
const AgreementTermsDisplay = (props) => {
    const { classes } = props;

    const closeDialog = () => {
        props.toggleTerms(false);
    };
    return (
        <Auxiliary>
            <MuiThemeProvider theme={DEFAULT_THEME}>
                <Dialog
                    open={props.openCloseTerms}
                    onClose={() => closeDialog()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Terms of Use</DialogTitle>
                    <DialogContent>
                        <Paper className={classes.root} elevation={1}>
                            <Grid container spacing={24}>
                                <Grid item xs={12}>
                                    <div className={cs(classes.termsAlignDisplay)}>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: props.termsAndConditions.terms
                                            }}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </Paper>
                    </DialogContent>
                    <DialogActions>
                        <Button id="rCancel" onClick={() => closeDialog()} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </MuiThemeProvider>
        </Auxiliary>
    );
};

const mapStateToProps = (state) => ({
    termsAndConditions: state.termsAndConditions.termsAndConditions,
    openCloseTerms: state.termsAndConditions.openCloseTerms
});

export default connect(mapStateToProps, { toggleTerms })(
    withStyles(AgreementTermsStyle)(AgreementTermsDisplay)
);
